/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".video-call[_ngcontent-%COMP%]{font-size:2rem}.invited[_ngcontent-%COMP%]{color:#ccc}"];
export { styles as styles };
